(function() {
    'use strict';

a3_cabin_reports.factory('MisconnectionFlightsFactory', MisconnectionFlightsFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name MisconnectionFlightsFactory
    * @description 
    * Get selected flight info
    * @ngInject
    */ 
function MisconnectionFlightsFactory(GenericService) {
    
    var service = {

        setMisconnectionFlights: setMisconnectionFlights,
        getMisconnectionFlights: getMisconnectionFlights,
        getMisconnectionFlightsByFlightIdFromLS: getMisconnectionFlightsByFlightIdFromLS,
        upsertMisconnectionFlights: upsertMisconnectionFlights,
        cleanOldDataMisconnectionFlights: cleanOldDataMisconnectionFlights
    };

    /**
    * Initialize the MisconnectionFlights
    * @memberof MisconnectionFlightsFactory
    */
    function MisconnectionFlight() {
        this.DisruptedFlightId = null;
        this.DisruptedFltNo= null;
        this.DisruptedFlightCarrier= null;
        this.DisruptedFlightDate= null;
        this.DisruptedFlightDepature= null;
        this.DisruptedFlightArrival= null;
        this.DisruptedFlightDep_Gate= null;
        this.DisruptedFlightSTD = null;
        this.DisruptedFlightSTD_Local = null;
        this.DisruptedFlightETD= null;
        this.DisruptedFlightETD_Local = null;
        this.DisruptedFlightATD= null;
        this.DisruptedFlightATD_Local = null;
        //todo: additional fields for the connecting flight
        this.Passengers = [];
    }

    var objType = 'misconnectionFlightList';
    var objTypeCallback = MisconnectionFlight;

    /**
     * Save Misconnection Flights
     * @memberof MisconnectionFlightsFactory
     * @param {Array} misconnectionFlights
     */
    function setMisconnectionFlights(misconnectionFlights) {
        GenericService.saveAll(misconnectionFlights, objType);
    }

    /**
     * Get Misconnection Flights
     * @memberof MisconnectionFlightsFactory
     * @returns {Array} MisconnectionFlights
     */
    function getMisconnectionFlights() {
        return GenericService.list(objType, objTypeCallback);
    }

    /**
     * Get Misconnection Flights by FlightId from Local Storage
     * @memberof MisconnectionFlightsFactory
     */
    function getMisconnectionFlightsByFlightIdFromLS(flightId) {
        var storedMisconnectionFlights = getMisconnectionFlights();  
        return  storedMisconnectionFlights.filter(x => x.DisruptedFlightId == flightId);
    }

    function upsertMisconnectionFlights(misconnectionFlights) {
        var flightIds = misconnectionFlights.map(x => x.DisruptedFlightId);
        var storedMisconnectionFlights = getMisconnectionFlights();  
        var otherMisconnectionFlights = storedMisconnectionFlights.filter(x => !flightIds.includes(x.DisruptedFlightId));
        var mergeMisconnectionFlights = otherMisconnectionFlights.concat(misconnectionFlights);
        setMisconnectionFlights(mergeMisconnectionFlights);
    }

   /**
    * Clean Old Data Service Events
    * @memberof MisconnectionFlightsFactory
    * @param {Array} responseFlightIds
    */
    function cleanOldDataMisconnectionFlights(responseFlightIds){    
        var storedMisconnectionFlights = getMisconnectionFlights();  
        var previousMisconnectionFlights = storedMisconnectionFlights.filter(x => responseFlightIds.includes(x.DisruptedFlightId));
        setMisconnectionFlights(previousMisconnectionFlights);
    }

    return service;
}
})();